<template>
  <div>
    <!-- Mostrar mensaje si aún no cargó -->
    <div v-if="cargando">Cargando ...</div>

    <!-- Mostrar tablas -->
    <div v-else>
      <CrearProductoDialog
        :mostrar.sync="dialogNuevoProducto"
        :gridSeleccionado="gridSeleccionado"
        :cliente="auditoria?.cliente || null"
        :auditoriaUuid="auditoria.uuid"
        :producto="productoEditando"
        @guardado="emitirProductoGuardado" />

      <!-- botón añadir -->
      <v-btn color="primary" class="mb-4" @click="dialogElegirModo = true"> Añadir producto </v-btn>

      <!-- Dialog 1: Elegir modo -->
      <v-dialog v-model="dialogElegirModo" max-width="400px">
        <v-card>
          <v-card-title class="text-h6">Añadir producto</v-card-title>

          <v-card-text>
            <v-btn block color="primary" @click="elegirNuevo"> Añadir nuevo </v-btn>

            <v-btn block color="secondary" class="mt-3" @click="elegirIteracion">
              Desde iteración
            </v-btn>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogElegirModo = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog 2: Elegir GRID -->
      <v-dialog v-model="dialogElegirGrid" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Seleccione el tipo de producto</v-card-title>

          <v-card-text>
            <v-list two-line>
              <v-list-item
                v-for="grid in gridsAlcance"
                :key="grid.uuid"
                @click="seleccionarGrid(grid)">
                <v-list-item-content>
                  <v-list-item-title>{{ grid.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>Grid UUID: {{ grid.uuid }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogElegirGrid = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div v-for="grid in gridsAlcance" :key="grid.uuid" class="mb-10">
        <h3 class="text-h6 font-weight-bold mb-4">
          {{ grid.nombre }}
        </h3>

        <TablaProductosGrid
          :grid-config="grid.gridConfig"
          :productos="productosPorGrid[grid.uuid]" />
      </div>

      <div v-if="gridsAlcance.length === 0">
        <em>No hay grids que definan alcance.</em>
      </div>
    </div>
  </div>
</template>

<script>
import TablaProductosGrid from './TablaProductosGrid.vue'
import CrearProductoDialog from './CrearProductoDialog.vue'

export default {
  name: 'ProductosAuditoria',

  components: { TablaProductosGrid, CrearProductoDialog },

  props: {
    auditoria: { type: Object, required: true },
    subalcance: { type: Object, required: true },
  },

  data() {
    return {
      cargando: true,

      // datos de configuración
      grupos: [],
      configs: [],

      // diálogos
      dialogElegirModo: false,
      dialogElegirGrid: false,
      dialogNuevoProducto: false,

      // selección
      gridSeleccionado: null,
    }
  },

  computed: {
    gridsAlcance() {
      return this.configs
        .filter((cfg) => cfg.tipo === 'grid' && cfg.defineAlcance === true)
        .map((cfg) => ({
          uuid: cfg.uuid,
          nombre: cfg.nombre,
          codigoGrid: cfg.uuid,
          gridConfig: cfg.gridConfig,
        }))
    },

    productosPorGrid() {
      const mapa = {}

      if (!this.auditoria.productos) return mapa

      for (const grid of this.gridsAlcance) {
        mapa[grid.uuid] = []
        const columnas = grid.gridConfig.map((c) => c.nombre)

        for (const producto of this.auditoria.productos) {
          const nombresParams = producto.params.map((p) => p.nombre)
          const coincide = columnas.every((col) => nombresParams.includes(col))
          if (coincide) mapa[grid.uuid].push(producto)
        }
      }
      return mapa
    },
  },

  async created() {
    await this.cargarGrupos()
    await this.cargarConfigs()
    this.cargando = false
  },

  methods: {
    async cargarGrupos() {
      // ⭐ Aquí pon tu store en vez de axios — yo solo dejo estructura
      const res = await this.$axios.$get(`/grupo_configs?subalcance.uuid=${this.subalcance.uuid}`)
      this.grupos = res['hydra:member'] || []
    },

    async cargarConfigs() {
      this.configs = []
      for (const grupo of this.grupos) {
        const res = await this.$axios.$get(`/subalcance_configs?grupo.uuid=${grupo.uuid}`)
        this.configs.push(...(res['hydra:member'] || []))
      }
    },

    elegirNuevo() {
      this.dialogElegirModo = false
      this.dialogElegirGrid = true
    },

    elegirIteracion() {
      this.dialogElegirModo = false
      // pendiente
    },

    seleccionarGrid(grid) {
      this.gridSeleccionado = grid
      this.dialogElegirGrid = false
      this.dialogNuevoProducto = true
      this.productoEditando = null
    },

    emitirProductoGuardado(producto) {
      // simple proxy hacia el padre del todo (_uuid.vue)
      this.$emit('producto-guardado', producto)
    },
  },
}
</script>
